var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.3787 25.6711L16.6061 7.1033C16.5439 7.0544 16.4693 7.02401 16.3907 7.01562C16.3121 7.00723 16.2327 7.02118 16.1616 7.05588C16.0906 7.09057 16.0308 7.1446 15.9891 7.21175C15.9473 7.27891 15.9254 7.35647 15.9258 7.43553V11.5119C15.9258 11.7703 16.0471 12.0181 16.2475 12.1764L35.2318 27L16.2475 41.8236C16.0418 41.9818 15.9258 42.2297 15.9258 42.4881V46.5644C15.9258 46.9178 16.3318 47.1129 16.6061 46.8967L40.3787 28.3289C40.5808 28.1713 40.7442 27.9697 40.8566 27.7394C40.9691 27.5091 41.0275 27.2562 41.0275 27C41.0275 26.7437 40.9691 26.4909 40.8566 26.2606C40.7442 26.0303 40.5808 25.8287 40.3787 25.6711Z","fill":"#333333"}));
}

ArrowRight.defaultProps = {"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
